import React from 'react';
import { ContentProps } from '../newron-core';

function DummyStaticContent(_: ContentProps) {
  return (
    <div className="py-14 rounded bg-blue-100 px-4 mb-4">
      <p>I'm a core dummy static element</p>
    </div>
  );
}

export { DummyStaticContent };
